import * as Yup from "yup";

export const memberSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, "Nome muito curto")
        .required("O nome é obrigatório"),
    lastName: Yup.string()
        .min(2, "Sobrenome muito curto")
        .required("O sobrenome é obrigatório"),
    email: Yup.string()
        .email("Digite um e-mail válido")
        .required("O e-mail é obrigatório"),
    phone: Yup.string()
        .required("O telefone é obrigatório"),
    document: Yup.string().nullable(), // CPF
    birthDate: Yup.string()
        .required("A data de nascimento é obrigatória")
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Data de nascimento inválida"),
    gender: Yup.string().nullable(),
    maritalStatus: Yup.string().nullable(),

    // Endereço
    zipCode: Yup.string().nullable(),
    address: Yup.string().nullable(),
    number: Yup.string().nullable(),
    complement: Yup.string().nullable(),
    neighborhood: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    country: Yup.string().nullable().default("Brasil"),

    // Contato de Emergência
    emergencyContact: Yup.object().shape({
        name: Yup.string().nullable(),
        phone: Yup.string().nullable(),
        email: Yup.string()
            .transform(value => (value === '' ? null : value))
            .email("E-mail inválido")
            .nullable(),
        relationship: Yup.string().nullable(),
    }),

    // Informações de Saúde
    healthInfo: Yup.object().shape({
        bloodType: Yup.string().nullable(),
        allergies: Yup.string().nullable(),
        medications: Yup.string().nullable(),
        medicalConditions: Yup.string().nullable(),
        observations: Yup.string().nullable(),
    }),

    status: Yup.string().default("lead"),
});
